const PAGINATION_PREFIX = 'point-expiration-schedule';
export const PAGINATION_PAGE_SIZE = 10;
export const PAGINATION_BEFORE_PARAM = `${PAGINATION_PREFIX}-before`;
export const PAGINATION_AFTER_PARAM = `${PAGINATION_PREFIX}-after`;
